import { StaticImageData } from "next/image";
import Link, { LinkProps } from "next/link";
import React, { ReactNode } from "react";
import IconExternal from "../../assets/external-link.svg";

type ButtonProps = {
  children: ReactNode;
  onClick?: () => void;
  className?: string;
  iconLeft?: StaticImageData;
  external?: boolean;
  color?: "default" | "yellow" | "dyn";
  fullWidth?: boolean;
  big?: boolean;
  rounded?: boolean;
};

export const Button = ({
  children,
  onClick,
  className,
  iconLeft,
  external,
  color = "default",
  fullWidth = false,
  big = false,
  rounded = false,
}: ButtonProps) => {
  const getColor = () => {
    switch (color) {
      case "dyn":
        return "bg-dyn";
      case "yellow":
        return "bg-gradient-to-b from-yellow to-orange";
      default:
        return "bg-gradient-to-b from-blue to-dark-blue";
    }
  };

  return (
    <button
      className={`
      ${className || ""} 
      relative inline-flex items-center justify-center rounded text-white font-antonio font-bold uppercase text-center hover:shadow-md transition-shadow duration-300
      ${getColor()} 
      ${iconLeft || external ? "px-20" : "px-8"} 
      ${big ? "py-2 text-xl" : "py-2 text-lg"}
      ${fullWidth ? "w-full" : ""}
      ${rounded ? "rounded-full" : ""}
      `}
      onClick={() => onClick}
    >
      {iconLeft && (
        <div
          className="absolute w-full h-full bg-[auto_1em] bg-[0.5em] bg-no-repeat"
          style={{ backgroundImage: `url('${iconLeft?.src}')` }}
        />
      )}
      {external && (
        <div
          className="absolute w-full h-full bg-[auto_1em] bg-[center_right_0.5em] bg-no-repeat"
          style={{ backgroundImage: `url('${IconExternal.src}')` }}
        />
      )}
      <div className="flex items-center space-x-2 ">{children}</div>
    </button>
  );
};

type LinkButtonProps = LinkProps &
  ButtonProps & {
    linkClassName?: string;
    buttonClassName?: string;
  };

export const LinkButton = ({
  linkClassName,
  buttonClassName,
  children,
  iconLeft,
  external,
  fullWidth,
  big,
  color,
  rounded,
  ...linkProps
}: LinkButtonProps) => {
  return (
    <Link
      {...linkProps}
      className={`
        inline-flex 
        ${linkClassName} 
        ${fullWidth ? "w-full" : ""} 
      `}
    >
      <Button
        iconLeft={iconLeft}
        external={external}
        fullWidth={fullWidth}
        className={buttonClassName}
        big={big}
        color={color}
        rounded={rounded}
      >
        {children}
      </Button>
    </Link>
  );
};
